import { Link } from "react-router-dom";
import TrialezeLogo from "./TrialezeLogo";

const Footer = () => (
  <footer className="py-8 border-t border-slate-200 bg-white" data-testid="footer">
    <div className="container-shell">
      <div className="flex flex-col md:flex-row justify-between items-start gap-8">
        <div>
          <div className="mb-3">
            <TrialezeLogo size="small" />
          </div>
          <p className="text-sm text-slate-500 max-w-md">
            Legal intelligence platform. Transform case data into strategic insights.
          </p>
        </div>
        <div className="grid grid-cols-2 gap-8 text-sm">
          <div>
            <h4 className="font-semibold text-slate-700 mb-3">Platform</h4>
            <div className="space-y-2 text-slate-500">
              <Link to="/tools/analytics" className="block hover:text-slate-700 transition-colors">Matter Analytics</Link>
              <Link to="/tools/lytix" className="block hover:text-slate-700 transition-colors">Lytix Ledger</Link>
              <Link to="/tools/investigator" className="block hover:text-slate-700 transition-colors">The Investigator</Link>
            </div>
          </div>
          <div>
            <h4 className="font-semibold text-slate-700 mb-3">Legal</h4>
            <div className="space-y-2 text-slate-500">
              <Link to="/terms" className="block hover:text-slate-700 transition-colors">Terms of Service</Link>
              <Link to="/privacy" className="block hover:text-slate-700 transition-colors">Privacy Policy</Link>
              <Link to="/methodology" className="block hover:text-slate-700 transition-colors">Methodology</Link>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-8 pt-6 border-t border-slate-100">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-slate-500">
            864 Grand Ave Suite 408, San Diego, CA 92109 | Call: <span className="font-semibold text-slate-700">510-422-4451</span>
          </p>
          <p className="text-xs text-slate-400">
            Trialeze provides procedural analytics. It does not provide legal advice and does not guarantee outcomes.
          </p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
